export const API = "https://admin.bab-media.com/public/api/";
// Live URL
// export const API =
//     "https://bab-media.online/public/api/";
// Staging URL
export const DetailPageUrl = "https://bab-media.com/#/Detail";
